<template>
  <div class="dropdown-wrapper">
    <p v-if="dropdownLabel" class="dropdown-label">
      {{ dropdownLabel }}
    </p>
    <select
      class="form-control custom-dropdown"
      v-model="internalValue"
      @change="handleFilter()"
    >
      <option
        v-if="noneValueDisplay || !internalValue"
        class="non-value"
        value=""
        selected
        >{{ noneValueDisplay }}</option
      >
      <option
        class="value"
        v-for="(valueItem, index) in valueList"
        :value="valueItem"
        :key="index"
      >
        {{ displayList[index] }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  data() {
    return {
      internalValue: ''
    };
  },
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    dropdownLabel: {
      type: String,
      default: null
    },
    valueList: {
      default: []
    },
    displayList: {
      default: []
    },
    noneValueDisplay: {
      default: ''
    }
  },
  watch: {
    value() {
      if (this.internalValue !== this.value) {
        this.internalValue = this.value;
      }
    }
  },
  mounted() {
    this.internalValue = this.value;
  },
  methods: {
    handleFilter() {
      this.$emit('input', this.internalValue);
    }
  }
};
</script>

<style lang="scss" scoped>
.dropdown-wrapper {
  .dropdown-label {
    margin-bottom: 11px;
    text-align: left;
    font-family: Inter-Regular;
    font-size: 16px;
    line-height: 1;
    color: #ffffff;
    padding: 2px 0;
  }
  .custom-dropdown {
    height: 42px;
    border: 1px solid #f3f5fa;
    border-radius: 6px;
    background-color: #ffffff;
    font-size: 16px;
    line-height: 1;
    cursor: pointer;

    &:focus {
      box-shadow: none;
    }
  }
}
</style>
